import Vue from "vue"
import TourOrderListView from '@/components/tours/TourOrderListView.vue'
import TourOrderCalendarView from '@/components/tours/TourOrderCalendarView.vue'
import TourOrderKanbanView from '@/components/tours/TourOrderKanbanView.vue'
import TourOrderDetails from '@/components/tours/TourOrderDetails.vue'

Vue.component('TourOrderListView', TourOrderListView)
Vue.component('TourOrderCalendarView', TourOrderCalendarView)
Vue.component('TourOrderKanbanView', TourOrderKanbanView)
Vue.component('TourOrderDetails', TourOrderDetails)